/* eslint-disable */
import createIcon from '../createIcon';

const IconCheckCircleOutlined = createIcon({
  name: 'icon-check-circle-outlined',
  content: '<path d="M513.593 955.818a446.049 446.049 0 01-316.057-764.654A442.225 442.225 0 01509.77 63.72a446.049 446.049 0 01446.048 446.05A446.049 446.049 0 01509.77 955.818zm0-828.376h-3.823a382.327 382.327 0 000 764.655A382.327 382.327 0 00892.097 509.77 382.327 382.327 0 00509.77 127.442z"/><path d="M406.605 656.01l314.4-316.503 45.243 44.923-314.465 316.503z"/><path d="M315.42 475.806l180.777 179.63-44.923 45.243-180.777-179.694z"/>',
  width: 1024,
  height: 1024
});
export default IconCheckCircleOutlined;
